let featuredRoutes = {
    'en-us': [
        {
            departCity: 'Boston',
            arriveCity: 'New York',
            url: '/bus/us-ma/boston/us-ny/new-york',
            imageUrl: 'https://static.wanderu.com/cities/featured/NYC.jpg',
        },
        {
            departCity: 'New York',
            arriveCity: 'Boston',
            url: '/train/us-ny/new-york/us-ma/boston',
            imageUrl: 'https://static.wanderu.com/cities/featured/BOS.jpg',
        },
        {
            departCity: 'DC',
            arriveCity: 'Philadelphia',
            url: '/bus/us-dc/washington/us-pa/philadelphia',
            imageUrl: 'https://static.wanderu.com/cities/featured/PHL.jpg',
        },
        {
            departCity: 'DC',
            arriveCity: 'New York',
            url: '/train/us-dc/washington/us-ny/new-york',
            imageUrl: 'https://static.wanderu.com/cities/featured/NYC2.jpg',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
            imageUrl: 'https://static.wanderu.com/cities/featured/SEA.jpg',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAVAC.jpg',
        },
        {
            departCity: 'NYC',
            arriveCity: 'Baltimore',
            url: '/bus/us-ny/new-york/us-md/baltimore',
            imageUrl: 'https://static.wanderu.com/cities/featured/BAL.jpg',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'Las Vegas',
            url: '/bus/us-ca/los-angeles/us-nv/las-vegas',
            imageUrl: 'https://static.wanderu.com/cities/featured/LAS.jpg',
        },
    ],
    'en-ca': [
        {
            departCity: 'Toronto',
            arriveCity: 'Montreal',
            url: '/train/ca-on/toronto/ca-qc/montreal',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAMTL.jpg',
        },
        {
            departCity: 'Montreal',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/montreal/ca-on/toronto',
            imageUrl: 'https://static.wanderu.com/cities/featured/CATOR.jpg',
        },
        {
            departCity: 'Ottawa',
            arriveCity: 'Montreal',
            url: '/train/ca-on/ottawa/ca-qc/montreal',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAMTL.jpg',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Ottawa',
            url: '/train/ca-on/toronto/ca-on/ottawa',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAXDS.jpg',
        },
        {
            departCity: 'Québec City',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/quebec-city/ca-on/toronto',
            imageUrl: 'https://static.wanderu.com/cities/featured/CATOR2.jpg',
        },
        {
            departCity: 'Edmonton',
            arriveCity: 'Calgary',
            url: '/bus/ca-ab/edmonton/ca-ab/calgary',
            imageUrl: 'https://static.wanderu.com/cities/featured/CACGY.jpg',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'New York',
            url: '/train/ca-on/toronto/us-ny/new-york',
            imageUrl: 'https://static.wanderu.com/cities/featured/NYC.jpg',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/bus/ca-bc/vancouver/us-wa/seattle',
            imageUrl: 'https://static.wanderu.com/cities/featured/SEA.jpg',
        },
    ],
    'fr-ca': [
        {
            departCity: 'Montréal',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/montreal/ca-on/toronto',
            imageUrl: 'https://static.wanderu.com/cities/featured/CATOR.jpg',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Montréal',
            url: '/train/ca-on/toronto/ca-qc/montreal',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAMTL.jpg',
        },
        {
            departCity: 'Québec',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/quebec-city/ca-on/toronto',
            imageUrl: 'https://static.wanderu.com/cities/featured/CATOR2.jpg',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Québec',
            url: 'train/ca-on/toronto/ca-qc/quebec-city',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAXFY.jpg',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Québec',
            url: '/train/ca-qc/montreal/ca-qc/quebec-city',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAXFY2.jpg',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Ottawa',
            url: '/train/ca-qc/montreal/ca-on/ottawa',
            imageUrl: 'https://static.wanderu.com/cities/featured/CAXDS.jpg',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'New York',
            url: '/train/ca-qc/montreal/us-ny/new-york',
            imageUrl: 'https://static.wanderu.com/cities/featured/NYC.jpg',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Boston',
            url: '/bus/ca-qc/montreal/us-ma/boston',
            imageUrl: 'https://static.wanderu.com/cities/featured/BOS.jpg',
        },
    ],
};

const FEATURED_ROUTES = {
    ...featuredRoutes,
    'de-de': featuredRoutes['en-us'],
    'en-gb': featuredRoutes['en-us'],
    'es-es': featuredRoutes['en-us'],
    'es-mx': featuredRoutes['en-us'],
    'fr-fr': featuredRoutes['en-us'],
    'it-it': featuredRoutes['en-us'],
    'nl-nl': featuredRoutes['en-us'],
};

export {
    FEATURED_ROUTES,
};
